/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import styles from './Login.module.scss'
import LoginImage from '../../assets/img/login.png'
import { authUser } from '../../store/actions/authUser'
import { getUserInvoices } from '../../store/actions/invoices'

/**
* @author zilahir
* @function Login
* */

const Login = () => {
	const [username, setUserName] = useState('admin')
	const [password, setPassword] = useState('admin')
	// eslint-disable-next-line no-unused-vars
	const store = useStore()
	const dispatch = useDispatch()
	const history = useHistory()
	function handleLogin() {
		const authPromise = dispatch(authUser({ email: username, password }))
		Promise.all([
			authPromise,
		]).then(result => {
			if (result[0]) {
				const user = {
					authToken: result[0].accessToken,
					userId: result[0].userId,
				}
				const invoicePromise = dispatch(getUserInvoices(user))
				Promise.all([
					invoicePromise,
				]).then(() => {
					history.push('/dashboard')
				})
			}
		})
	}
	return (
		<div className={styles.rootContainer}>
			<div className={styles.loginSide}>
				<div className={styles.headerContainer}>
					<div className={styles.textContainer}>
						<p>
							Login
						</p>
						<p className={styles.subText}>
							to continue
						</p>
					</div>
				</div>
				<div className={styles.loginContainer}>
					<label>
						username
						<input value={username} onChange={e => setUserName(e.target.value)} className={styles.input} type="text" placeholder="Username" />
					</label>
					<label>
						password
						<input value={password} onChange={e => setPassword(e.target.value)} className={styles.input} type="password" placeholder="Password" />
					</label>
					<button onClick={handleLogin} className={styles.button} type="button">
						Login
					</button>
				</div>
			</div>
			<div className={styles.metaSide}>
				<div>
					<img className={styles.loginImage} src={LoginImage} alt="login" />
				</div>
			</div>
		</div>
	)
}

export default Login
